<template>
  <div class="Header">
      <router-link to="/">
          <img src="../assets/img/hlogo.png" />
      </router-link>
  </div>

  <div class="header-in fixed-top">
    <div class="d-flex align-items-center justify-content-center">
      <router-link to="/">
        <img src="../assets/img/hlogo.png" alt="Heybourne Park Logo" class="logo" width="50"/>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
  return {
    route: "",
  };
},
  created () {
  },
  watch: {
  $route(to, from) {
    this.route = to.fullPath;
  }
},
methods:{
}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">

.fixed-top {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 9 !important;
    border-bottom:2px solid #cad636;
}

.footer {
  height: 70px;
  background-color: #381b31;
  color: white;
  width: 100%!important;
  div {
      width: calc(100%/8);
      span {
          border: none !important;
      }
  }

 

  .footer-box {
      text-transform: uppercase;
      a{
          color: #fff;
          text-decoration: none;
          border: none;
      }
      .footer-icons {
          width: 40px;
          height: 40px;
          object-fit: contain;
          margin-right: 10px;
      }
      .name{
          letter-spacing:3px;
          font-size: 15px;
          font-weight:700
      }
      
      .item-box{
          display: none;
          position: absolute;
          top: -70px;
          height: 70px;
          left:  calc(14.28% * 1);
          background: #fff;
          width: 300px;
          div{
              width: 100%;
              height: 70px;
              border: none;
              padding: 0;

              .active-box{
                  background-color: #1F3646 !important;
              }
              
              .arrow{
                  background-color: #355063;
              }

              .inner-icons{
                  width: 30px;
              }

             
          }
      }

      .leaf {
              height: 30px;
              width: auto !important; 
          }

      .gallery-box{
          display: none;
          position: absolute;
          top: -70px;
          height: 70px;
          left:  calc(14.28% * 2);
          background: #fff;
          width: 300px;
          cursor: pointer;
          div{
              width: 100%;
              height: 70px;
              border: none;
              padding: 0;

              .active-box{
                  background-color: #1F3646 !important;
              }
              
              .arrow{
                  background-color: #355063;
              }

              .inner-icons{
                  width: 30px;
              }
          }
      }

      .specs-box{
          display: none;
          position: absolute;
          top: -70px;
          height: 70px;
          left: calc(14.28% * 4);
          background: #fff;
          width: 300px;
          cursor: pointer;
          div{
              width: 100%;
              height: 70px;
              border: none;
              padding: 0;

              .active-box{
                  background-color: #1F3646 !important;
              }
              
              .arrow{
                  background-color: #355063;
              }

              .inner-icons{
                  width: 30px;
              }
          }
      }

      &:hover{
          .item-box{
              display: block;
          }
          .gallery-box{
              display: block;
          }
          .specs-box{
              display: block;
          }
          
      }

      
  }

  .footer-img {
      height: 100%;
      img {
          width: 100%;
          height: 100%;
          object-fit:cover;
      }
  }

  .rightfooter{
      text-align:center;
      vertical-align: middle;
       img {
          width: auto !important;
          height: 60px !important;
          margin-top: 5px;
          padding: 3px;
      }
  }
}

.Header {
  position: fixed;
  top: 25px;
  right: -10px;
  text-decoration: none;
  z-index: 2;
  //transform: rotate(-90deg) translate3d(-25px, 39px, 0);
  color: #fff;
  background: #381b31;
  padding: 20px;
  border: 2px solid #cad636;
  border-radius: 10px 0px 0px 10px;

  img{
      width:120px
  }
}

.header-in {
  display:none !important;
}

@media screen and (max-width: 1024px) {
  .Header {
      display:none
  }

  .header-in {
      display:block !important;
      background: #381b31;
      height:70px;
      padding: 10px;
  }
 
}

</style>
